module.exports = __webpack_public_path__ + "static/media/image15.b1430032.png";